import { render } from "./FootballHistory.vue?vue&type=template&id=43340720&scoped=true"
import script from "./FootballHistory.vue?vue&type=script&lang=js"
export * from "./FootballHistory.vue?vue&type=script&lang=js"

import "./FootballHistory.vue?vue&type=style&index=0&id=43340720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43340720"]])

export default __exports__